import { BASE_PDF_STYLES } from '../../../../utils/reportUtils';
import React from 'react';
import ReportButton from '../../../components/report/ReportButton';

const pdfStyles = `
${BASE_PDF_STYLES}

body.pdfBody .drilldownHeader {
    margin-left: auto!important;
}

body.pdfBody .drilldownContent {
    max-width: 600px; 
}

`;

type PolicyDrilldownReportProps = {
  elementRef: React.MutableRefObject<HTMLElement | null>;
};

const PolicyDrilldownReport = ({ elementRef }: PolicyDrilldownReportProps) => {
  return (
    <ReportButton
      elementToPrintRef={elementRef}
      fileName="Policy_Drilldown_Report"
      pdfStyles={pdfStyles}
      noButton={true}
      isPdfPortrait={true}
      widthElementID="policy-drilldown"
      minWidth={600}
      hideExcel={true}
    />
  );
};

export default PolicyDrilldownReport;
